import React from "react";
import { Avatar, AvatarImage, AvatarFallback } from "@/components/ui/avatar";
import { IMember } from "@/types/person";

interface MemberItemProps {
  member: IMember;
  className?: string;
}

// Calculate age from date of birth
const calculateAge = (dateOfBirth: Date): number => {
  const today = new Date();
  const birthDate = new Date(dateOfBirth);
  let age = today.getFullYear() - birthDate.getFullYear();
  const monthDiff = today.getMonth() - birthDate.getMonth();

  if (
    monthDiff < 0 ||
    (monthDiff === 0 && today.getDate() < birthDate.getDate())
  ) {
    age--;
  }

  return age;
};

export const MemberItem: React.FC<MemberItemProps> = ({ member, className }) => {
  const age = member.dateOfBirth ? calculateAge(member.dateOfBirth) : null;

  return (
    <div className={`flex items-center ${className}`}>
      <Avatar className="h-10 w-10 mr-3 ring-2 ring-slate-100">
        <AvatarImage
          src={member.profilePic?.url}
          alt={`${member.firstName} ${member.lastName}`}
          className="object-cover"
        />
        <AvatarFallback className="text-sm font-medium bg-slate-100 text-slate-600">
          {member.firstName.charAt(0)}
          {member.lastName.charAt(0)}
        </AvatarFallback>
      </Avatar>
      <div className="flex flex-col min-w-0 flex-1">
        <span className="text-lg font-medium text-slate-500 truncate">
          {member.firstName} {member.secondName} {member.lastName}
        </span>
        <div className="flex items-center gap-2 text-sm text-slate-500 truncate">
          {age && <span>{age} years</span>}
          {member.mobile && age && <span>•</span>}
          {member.mobile && <span>{member.mobile}</span>}
        </div>
      </div>
    </div>
  );
}; 